import React, { useState, useRef } from "react";
import ApprovedModal from './ApprovedModal.js'
import Square from './Square.js'

const CheckoutForm = (props) => {

  // console.log('Checkout Form', props.context)

  const cart = props.context.cart

  const [modalIsOpen,setIsOpen] = useState(false);
  const [paymentData, setPaymentData] = useState({})
  const [approvedData, setApprovedData] = useState({orderId: "..................", approved: false})
  const [loadSquare, setLoadSquare] = useState(false)

  const purchaseData = useRef({})

  async function openModal() {
      setIsOpen(true);
  }

  function closeModal(){
      setIsOpen(false);
  }

  const [canceledError, setCanceledError] = useState(false)

  const [formData, setFormData] = useState({
    first_name: props.context.user.first_name ?? "",
    last_name: props.context.user.last_name ?? "",
    email: props.context.user.email ?? "",
    phone: props.context.user.phone ?? "",
    company_name: props.context.user.company_name ?? "",
    address_1: props.context.user.address_1 ?? "",
    address_2: props.context.user.address_2 ?? "",
    city: props.context.user.city ?? "",
    state: props.context.user.state ?? "",
    postal_code: props.context.user.postal_code ?? "",
    items: props.context.user.items ?? [],
    total: props.total
  });

  const purchaseTrigger = function(data, id){

    // console.log('purchaseTrigger', data)

    window.dataLayer = window.dataLayer || []
    
    window.dataLayer.push({
        event: 'purchase',
        ecommerce: {
            affiliation: 'Online Store',
            transaction_id: id,
            value: data.total,
            currency: 'USD',
            items: data.items
        }
    })

  }

  function onApprove(data) {
    openModal()
    // This function shows a transaction success message to your buyer.
    setApprovedData({
      orderID: data.id,
      approved: true
    })
    setCanceledError(false)
    purchaseTrigger(purchaseData.current, data.id)
    props.context.actions.updateState("approved", true)
  }

  function onCancel(data, actions) {
    console.log('Canceled')
    console.log('Data', data)
    console.log('Actions', actions)
    setCanceledError(true)
  }

  const handleChanges = event => {
    event.preventDefault();
    setFormData({
      ...formData,
      [event.target.name]: event.target.value
    });
    // console.log(formData);
  };

  const transferCart = function(){
    let newCart = []
    let purchaseDataCart = []
    let subTotal = 0;

    // console.log('Cart', cart)

    if (cart[0].name.includes("Test")){
      console.log('TEST ITEM DETECTED')
      for (let i = 0; i <= cart.length -1;i++){
        newCart.push({
          name: cart[i].name,
          quantity: `${cart[i].quantity}`,
          basePriceMoney:{
            amount: `1`,
            currency: "USD",
          },
            
        })

        subTotal += 1 * cart[i].quantity //calculate total
      }
      setFormData({
        ...formData,
        items: newCart,
        total: `${subTotal}`
        // total: `${subTotal}` //testing only
      });
    } else {
      for (let i = 0; i <= cart.length -1;i++){
        newCart.push({
          name: cart[i].name,
          label: cart[i].name, //For ApplePay
          amount: `${cart[i].price}`, //For ApplePay must not add '00'
          quantity: `${cart[i].quantity}`,
          basePriceMoney:{
            amount: `${cart[i].price}00`,
            currency: "USD",
          },
            
        })

        purchaseDataCart.push({
          item_name: cart[i].name,
          price: `${cart[i].price}`,
          quantity: `${cart[i].quantity}`
        })

        subTotal += cart[i].price * cart[i].quantity //calculate total
      }
      setFormData({
        ...formData,
        items: newCart,
        total: `${subTotal}00`
        // total: `${subTotal}` //testing only
      });
      purchaseData.current = {
        ...formData,
        items: purchaseDataCart,
        total: `${subTotal}`
      };
      // console.log('purchaseData', purchaseData.current)
    }
  }

  const formValidation = function(input, formField){
    const formInputs = document.getElementsByClassName("form-input")
    let validated = []
    let start = 0;
    let end = -1;
    if (input === "billing"){
      end = 2
    } else if (input === "payment"){
      start = 0
      end = formInputs.length - 1
    } else if (input === "client"){
      validated = [true] //Add so user can return to client fields
    }
    for (let i = start; i <= end; i++){
      if (formInputs[i].value === "" && formInputs[i].name !== "phone" && formInputs[i].name !== "company_name" && formInputs[i].name !== "address_2"){
        // console.log("Checking ", formInputs[i].name, "=", formInputs[i].value)
        formInputs[i].style.border = "1px solid red"
        // formInputs[i].placeholder = `${formInputs[i].ariaLabel} required!` //disabled for mobile browsers
        validated.push(false)
      } else {
        formInputs[i].style.border = "1px solid grey"
        // formInputs[i].placeholder = `${formInputs[i].ariaLabel}`
        validated.push(true)
      }
    }
    return !validated.includes(false)
  }

  const toggleFormFields = function(e, input) {
    e.preventDefault()
    const formFields = document.getElementsByClassName("form-fields")
    const formInfos = document.getElementsByClassName("info")
    const formField = document.getElementById(`${input}`)
    const formInfo = document.getElementById(`${input}-info`)
    if (!formValidation(input, formField)){
      return //if formValidation returns false, exit function
    }
    for (let i = 0; i <= formFields.length - 1; i++){
      formFields[i].style.display = "none";
    }
    for (let i = 0; i <= formInfos.length - 1; i++){
      formInfos[i].style.display = "flex"
    }

    if (input === "payment"){
      transferCart() //parse cart data and calculate total
      formField.style.display = "block";
      props.context.actions.updateState("user", formData)
      props.context.actions.saveUserSession(formData)
      // setPaymentData(formData) //sets paymentData here to ensure state is correct
      setPaymentData(()=> (formData)) //sets paymentData here to ensure state is correct
      setLoadSquare(true) //set to false for testing
      // onApprove({id: 'test id'})// call onApprove for testing
    } else{
      formField.style.display = "flex";
    }
    formInfo.style.display = "none";
  }

  // const continueButton = (e, input) => {
  //   e.preventDefault()
  //   console.log('continue', input)
  // }

  return (
          <div className="forms-container">
            <form className="checkout-form">
              <div className="form-container" onClick={(e) => toggleFormFields(e, "client")} role="button" aria-label="Client" aria-pressed="false" tabIndex="0">
                <div className="form-heading">
                  <div className="dot"></div>
                  <h2>Client</h2>
                </div>
                <div className="form-fields" id="client">
                  <label className="form-label" htmlFor="first_name">First Name</label>
                  <input className="form-input" type="text" id="first_name" name="first_name" defaultValue={formData.first_name} placeholder="first name" aria-label="first name" onChange={handleChanges} required/>
                  <label className="form-label" htmlFor="last_name">Last Name</label>
                  <input className="form-input" type="text" id="last_name" name="last_name" defaultValue={formData.last_name} placeholder="last name" aria-label="last name" onChange={handleChanges} required/>
                  <label className="form-label" htmlFor="email">Email</label>
                  <input className="form-input" type="email" id="email" name="email" defaultValue={formData.email} placeholder="email address" aria-label="email address" onChange={handleChanges} required/>
                  <label className="form-label" htmlFor="tel">Phone Number</label>
                  <input className="form-input" type="tel" id="phone" name="phone" defaultValue={formData.phone} placeholder="phone number" aria-label="phone number" onChange={handleChanges}/>
                  {/* <button className="button" onClick={(e) => continueButton(e, "billing")} aria-label="Continue" aria-pressed="false" tabIndex="0">Continue</button> */}
                </div>
                <div className="info" id="client-info">
                  <p>{formData.first_name} {formData.last_name}</p>
                  <p>{formData.email}</p>
                  <p>{formData.phone}</p>
                </div>
              </div>

              <div className="form-container" onClick={(e) => toggleFormFields(e, "billing")} role="button" aria-label="Billing" aria-pressed="false" tabIndex="0">
                <div className="form-heading">
                  <div className="dot"></div>
                  <h2>Billing</h2>
                </div>
                <div className="form-fields" id="billing">
                  <label className="form-label" htmlFor="company_name">Company Name</label>
                  <input className="form-input" type="text" id="company_name" name="company_name" defaultValue={formData.company_name} placeholder="company name" aria-label="company name" onChange={handleChanges}/>
                  <label className="form-label" htmlFor="address_1">Address</label>
                  <input className="form-input" type="text" id="address_1" name="address_1" defaultValue={formData.address_1} placeholder="address" aria-label="address 1" onChange={handleChanges}/>
                  <label className="form-label" htmlFor="address_2">Apartment/Suite/Building</label>
                  <input className="form-input" type="text" id="address_2" name="address_2" defaultValue={formData.address_2} placeholder="apartment/suite/building" aria-label="address 2" onChange={handleChanges}/>
                  <label className="form-label" htmlFor="city">City</label>
                  <input className="form-input" type="text" id="city" name="city" defaultValue={formData.city} placeholder="city" aria-label="city" onChange={handleChanges}/>
                  <div className="form-half">
                    <label className="form-label" htmlFor="state">State</label>
                    <input className="form-input" type="text" id="state" name="state" defaultValue={formData.state} placeholder="state" aria-label="state" onChange={handleChanges}/>
                    <label className="form-label" htmlFor="postal_code">Postal Code</label>
                    <input className="form-input" type="text" id="postal_code" name="postal_code" defaultValue={formData.postal_code} placeholder="postal code" aria-label="postal code" onChange={handleChanges}/>
                  </div>
                  {/* <button className="button" type="submit">Continue</button> */}
                </div>
                <div className="info" id="billing-info">
                  <p>{formData.company_name}</p>
                  <p>{formData.address_1}</p>
                  <p>{formData.address_2}</p>
                  <p>{formData.city} {formData.state}</p>
                  <p>{formData.postal_code}</p>
                </div>
              </div>

              <div className="form-container" onClick={(e) => toggleFormFields(e, "payment")} role="button" aria-label="Payment" aria-pressed="false" tabIndex="0">
                <div className="form-heading">
                  <div className="dot"></div>
                  <h2>Payment{canceledError && (<div className="canceledError"> -Canceled- Please try again... </div>)}</h2>
                </div>
                <div className="form-fields" id="payment">
                  {/* Payment Form Here */}
                  {loadSquare ? (<Square onApprove={onApprove} onCancel={onCancel} paymentData={paymentData} buttonTotal={props.total} {...props} />):(<>Loading Square...</>)}
                </div>
                <div className="info" id="payment-info">
                </div>
              </div>
            </form>
            <ApprovedModal modalIsOpen={modalIsOpen} closeModal={closeModal} approvedData={approvedData} context={props.context} props={props} paymentData={paymentData}/>
          </div>
  );
};

export default CheckoutForm;
